<template>
  <div>
    <div class="sr-only">
      <label for="formatDecimalPlaces">Number of Decimal Places</label>
    </div>
    <input
      id="formatDecimalPlaces"
      type="number"
      @blur="model.defaultNumericValidation()"
      v-model.number="model.decimal_places"
      placeholder="Number of Decimal Places"
      :disabled="disabled"
    />
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import {IDecimalPlaces} from "../interfaces/propertyInterfaces";
  import {InputFormatType} from "../../formability/form_builder/models/inputFormatType";
  import disabledMixin from "../mixins/disabledMixin";

  export default Vue.extend({
    mixins: [disabledMixin],
    props: {
      model: {
        type: Object as () => IDecimalPlaces,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data: function () {
      return {};
    },
    watch: {
      'model.format_type': function (newVal, oldVal): void {
        if (newVal !== this.model.format_type) {
          if (newVal === InputFormatType.Numeric) {
            this.model.defaultNumericValidation();
          }
        }
      },
    }
  });
</script>
